
import moment from 'moment';
import { Component, Vue } from 'vue-property-decorator';
import Pagination from '@/components/Pagination/index.vue';
import { getReservationCalendar } from '@/api/reservationItem';
import { getStayRoomListAll } from '@/api/stayRoom';
import { getReservationClientList, cancelReservationClient } from '@/api/reservationClient';
import Calendar from '@/components/Calendar/index.vue';
import Refund from './components/refund.vue';

@Component({
  components: {
    Calendar,
    Pagination,
    Refund,
  },
})
export default class extends Vue {
  mounted() {
    this.getStayRoomList();
  }

  private roomList = [];

  private listQuery: any = {
    page: 0,
    size: 10,
    searchType: 'name',
    searchValue: '',
    useStart: '',
    useEnd: '',
  }

  private totalElements = 0;

  private clientList: any = [];

  private loading = true;

  private refundFormVisible = false;

  private selectedClientUid = '';

  private calendarData = null;

  private calendarLoading = false;

  private selectedMonth = moment().format('YYYY-MM');

  private getStayRoomList() {
    getStayRoomListAll().then((res) => {
      this.roomList = res.data;
    });
  }

  private handleClickView(client: any) {
    this.$router.push({ name: 'ReserveClientDetail', params: { uid: client.uid } });
  }

  private getReservationCalendar() {
    this.calendarLoading = true;
    getReservationCalendar(this.$route.params.itemUid, { selectedMonth: `${this.selectedMonth}` }).then((res) => {
      this.calendarData = res.data;
      this.calendarLoading = false;
    });
  }

  private handleChangeMonth(yearMonth: any) {
    this.selectedMonth = moment(yearMonth).format('YYYY-MM');
    this.getReservationCalendar();
  }
}
